<div class='errorPage infra-access-denied-container'>
  <label class="alert-section" aria-live="assertive" role="alert">Access Denied Page</label>
  <h1 class='error-text'>{{accessDeniedHeader}}</h1>
  <div class='error-img'>
    <img src="../../assets/images/AccessFailEmoji.svg" alt="Frown image" />
  </div>
  <p class='error-message'>{{accessDeniedText}}</p>

</div>
